import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_VENDOR_LIST_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { vendorsFailure, vendorsSuccess } from '../actions';

const vendorsAPI = (action) => postApiRequest(PROOFREADER_VENDOR_LIST_API_URL, action);

function* handleVendorsAPI(action) {
  try {
    const response = yield call(vendorsAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorsSuccess(response));
  } catch (error) {
    yield put(vendorsFailure(error));
  }
}

export function* watchVendors() {
  yield takeLatest(types.GET_VENDORS_LIST_REQUEST, handleVendorsAPI);
}
